import React from "react";

type Props = { className?: string; size?: number };

const TutorialIcon: React.FC<Props> = ({ className, size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.58 12.949c.068 1.526-1.164 2.817-2.751 2.882-.117.005-5.816-.006-5.816-.006-1.58.12-2.962-1.015-3.087-2.536-.01-.114-.007-6.229-.007-6.229-.07-1.528 1.16-2.822 2.749-2.89.118-.006 5.81.005 5.81.005 1.587-.118 2.974 1.025 3.097 2.553.008.11.006 6.22.006 6.22Z"
      clipRule="evenodd"
    />
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.583 8.317 2.744-2.246a1.04 1.04 0 0 1 1.7.806L18.016 13c-.002.877-1.022 1.358-1.7.801l-2.734-2.245"
    />
  </svg>
);

export default TutorialIcon;
